/**
 * 工作流配置
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.workflow.MODEL + "/" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.workflow.MODEL, METHOD.POST, result);
	},
	/*async deleteRow() {
		return request(api.workflow.MODEL, METHOD.DELETE);
	},*/
	async modelSet(keyId) {
		return request(api.workflow.MODEL + "/" + keyId + '/deploy', METHOD.PUT);
	},

}

export default {dataApi}